import styled from 'styled-components';
import { COLOR_ORANGE, COLOR_WHITE } from '../../../assets/styles/colors';

export default styled.button`
  font-size: 18px;
  font-weight: 600;
  border: none;
  position: relative;

  &:disabled {
    opacity: 0.5;
  }

  svg {
    position: absolute;
    right: 20px;
    top: 13px;
  }

  ${({ size }) =>
    size === 'MEDIUM'
      ? `padding:7px 20px 9px 20px; font-size:16px;`
      : size === 'SMALL'
      ? `padding: 3px 16px 2px 16px; !important; font-size:14px !important;`
      : size === 'BIG'
      ? `padding:10px 40px 11px 40px !important;
         font-size:18px !important;
         text-transform:inherit !important`
      : `padding: 11px 40px 12px 40px;`};
  ${({ kind }) =>
    kind === 'PRIMARY'
      ? `color:${COLOR_WHITE};
      box-shadow: 0 0 15px 0 rgba(247, 147, 30, 0.4);
      background-image: linear-gradient(to left, #fab535, #f7931e);
      border-radius: 12px;
      &:disabled {
              color: #fff;
              background: linear-gradient(to left, #fab535, #f7931e);
            }`
      : kind === 'OUTLINED'
      ? `
      text-transform:uppercase;
      border: solid 1px #f7941f;
      border-radius: 12px;
      text-align:center;
      color:${COLOR_ORANGE};
      font-size:14px;
      padding: 9px 16px 8px 16px;
      background:transparent;`
      : kind === 'LINK'
      ? `color:${COLOR_ORANGE};
      padding:0px;background:none;
      text-decoration:underline;
      font-size:16px;
      text-align:left;`
      : ``};

  &:focus,
  &:active {
    outline: none;
  }

  &.no-text-transform {
    text-transform: initial;
    font-size: 16px;
  }
`;
